import React, { PropTypes } from 'react'
import cn from 'classnames'
import { FilterIcon } from 'components/easinsure/contracts'
import { iconMap } from './icon-map'
import { translate } from './translate'
import styles from './EasinsureContractsFilter.scss'

export const EasinsureContractsFilter = ({ contracts, filter, onFilter }) => (
	<div className={styles.contractFilters}>
		{iconMap.map((icon, key) => (
            <div
                key={key}
                className={cn(styles.contractIcon, !contracts[key] && styles.empty, key === filter && styles.active)}
                onClick={() => contracts[key] && onFilter(key)}
            >
                <FilterIcon iconValue={icon}/>
                <p>{translate(icon.name)}</p>
            </div>
		))}
	</div>
)
EasinsureContractsFilter.propTypes = {
    contracts: PropTypes.object,
    filter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onFilter: PropTypes.func,
}




// WEBPACK FOOTER //
// ./components/easinsure/contracts/EasinsureContractsFilter.jsx